export const WEALTH_ANALYSIS_STEPS = [
  {
    id: 'home-purchase',
    stepName: 'HomePurchase',
  },
  {
    id: 'current-value',
    stepName: 'CurrentValue',
  },
  {
    id: 'mortgage',
    stepName: 'Mortgage',
  },
  {
    id: 'hoa',
    stepName: 'HomeOwnerAssociation',
  },
  {
    id: 'rent-supply',
    stepName: 'RentSupply',
  },
  {
    id: 'rent-range',
    stepName: 'RentRange',
  },
];
